import { type ImageType, getImageUrl } from "@/lib/getImageUrl";
import { createContext, useContext } from "react";

export interface ImageContext {
	imageUrlBase: string;
}

export const imageContext = createContext<ImageContext>({
	imageUrlBase: "",
});

export const useImageContext = () => {
	const imgCtx = useContext(imageContext);

	return {
		getImageUrl: (
			card_id: string,
			image_type: ImageType,
			side: "front" | "back" = "front",
		) => getImageUrl(imgCtx.imageUrlBase, card_id, image_type, side),
		imageUrlBase: imgCtx.imageUrlBase,
	};
};
